export class BankDetailsModel {
  bsb: string = '';
  accountNumber: string = '';
  accountName: string = '';
  reference: string = '';
}
